import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Poking a sleeping giant",
  "description": "",
  "published": "2011-11-01T00:00:00.000Z",
  "redirect_from": ["/blog/poking-a-sleeping-giant/swizec/2825"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The first `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Postcard",
        "title": "Postcard"
      }}>{`postcard`}</a>{` is said to have appeared in 1840 - it was a hand painted design on a piece of thick paper, sent with a penny black stamp to the writer `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Theodore_Hook",
        "title": "Theodore Hook"
      }}>{`Theodore Hook`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Conlie_postcard.jpg",
        "alt": null,
        "title": "First postcard"
      }}></img></p>
    <p>{`Since then not much has changed, the stock image postcards appeared in1848 as part of some sort of advertising. The modern postcard was born around 1870 when `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Camp_Conlie",
        "title": "Camp Conlie"
      }}>{`Camp Conlie`}</a>{` started offering stock postcards with photos of the place to send home as a memory.`}</p>
    <p><em parentName="p">{`tl;dr -> `}<a parentName="em" {...{
          "href": "http://postme.me"
        }}>{`postme.me`}</a>{` is making postcards cool again`}</em></p>
    <p>{`And that pretty much cemented the fate of the postcard. For the past 140 years they have mostly been seen as a way to send a picture of where you were for vacation back home to family or friends. The most variance happens in the form of holiday greeting cards, sometimes you'll see a postcard with a cheesy joke as well ... I think I've seen all 10 already. And they're the kind of joke your dad finds funny.`}</p>
    <p>{`That's it. `}<em parentName="p">{`That`}</em>{` is a `}<em parentName="p">{`five billion dollar industry`}</em>{`. Or so I've heard ... either way, something as lame as that is big business.`}</p>
    <p>{`How nobody has gone and poked in this hive before is beyond belief.`}</p>
    <p>{`Then suddenly, in early 2011, disruptors start popping up. Suddenly everyone thinks you should be able to send postcards electronically and easily. Just take a photo with your iphone or something, click a few buttons, and voila, some hapless victim gets a nice postcard.`}</p>
    <p>{`Now you can go on vacation and send back home what you actually see. A beautiful picture, filtered to the 70's, and everybody is happy. `}<a parentName="p" {...{
        "href": "http://techcrunch.com/2011/10/26/sincerely-raises-3-million-to-deliver-real-world-postcards-holiday-cards-on-the-way/"
      }}>{`Sincerely even got a 3 million dollar investment`}</a>{` last week for doing just that - letting people send boring postcards more easily. There's also `}<a parentName="p" {...{
        "href": "https://www.picplum.com/"
      }}>{`picplum`}</a>{`, which lets people mail gorgeously printed photos and was funded by YC this summer.`}</p>
    <p>{`Boring.`}</p>
    <p>{`A huge 140 year old industry and the best disruption we can come up with is making it marginally easier to use? What the hell is wrong with everyone!?`}</p>
    <p>{`There is a whole generation of people coming out of college and into the working world right now who have grown up with the internet. A generation of people who don't really care about holiday greetings or sending memories of their travels to family.`}</p>
    <p>{`But we share `}<em parentName="p">{`so many`}</em>{` pictures every freaking day. Imgur is booming right now, it's the 4chan for the everyman and it is absolutely brimming with silly pictures ... often seasonal and very meaningful pictures.`}</p>
    <p>{`When my friend had a birthday two weeks ago she didn't get a single `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Greeting_card",
        "title": "Greeting card"
      }}>{`greeting card`}</a>{`. She got ten silly pictures on facebook and somebody even made her a custom rage comic. That's right, a rage comic just to wish her a happy birthday.`}</p>
    <p>{`But that comic will be gone in the millions of other pictures within months. Or maybe she downloaded it and it will be gone in 5 years when her hard drive fails. Perhaps 10 years if she's really careful with backups. (not to mention the thousands other pictures vying for the same sliver of attention on that hard drive)`}</p>
    <p>{`What if instead she got that rage comic as a postcard, delivered to her address in all its glory, ready to be pinned on a wall?`}</p>
    <p>{`I think it would be much awesomer.`}</p>
    <p>{`What about Christmas? I haven't gotten or sent a christmas card in so long I can hardly remember the tradition existing. But every year I see hundreds of funny pictures on the topic of Christmas donning the internets.`}</p>
    <p>{`I think it would be superb if some of those made it onto postcards to my friends.`}</p>
    <p>{`When I started `}<a parentName="p" {...{
        "href": "http://postme.me"
      }}>{`postme.me`}</a>{` I didn't have a vision, I just wanted to make something fun. But I think there is an underlying reason why everyone likes the idea so much, young people don't care about boring, we want fun postcards.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.firstchoice.co.uk/postcards-from-the-edge/"
        }}>{`Postcards From The Edge`}</a>{` (firstchoice.co.uk)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.ancestry.com/uk/2011/02/10/postcard-posers-february/"
        }}>{`Postcard Posers - February`}</a>{` (blogs.ancestry.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gemakarolina.wordpress.com/2011/10/31/i-sent-the-man-with-a-restless-spirit-a-postcard/"
        }}>{`I sent the "man with a restless spirit" a postcard`}</a>{` (gemakarolina.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.makeuseof.com/tag/create-send-real-postcard-phone-postcard-run/"
        }}>{`Create & Send A Real Postcard With Your Phone Using Postcard On The Run`}</a>{` (makeuseof.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.brainpickings.org/index.php/2011/10/31/nypl-vintage-halloween-postcards/"
        }}>{`Vintage Halloween: Haunted Postcards from the 1910s`}</a>{` (brainpickings.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=878e6c75-2e0a-4454-98f6-8b63ec3f2e4e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      